import { Component, Output, EventEmitter, Input } from '@angular/core';
import {
	MatterAdjustmentDepositRecordCalculated,
	MatterFields,
} from '@models/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ICON } from '@core/util/icon';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatDialog } from '@angular/material/dialog';
import {
	DepositDialogComponent,
	DepositDialogData,
} from '../../adjustments/deposit-dialog';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';

@Component({
	selector: 'app-sale-deposit',
	templateUrl: './deposit.component.html',
	standalone: false,
})
export class DepositComponent {
	@Output() onFocus = new EventEmitter<string>();
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@ViewSelectSnapshot(AdjustmentsSelector.depositAdjustmentCalculated)
	depositTotal: MatterAdjustmentDepositRecordCalculated;

	@Input() label: string;
	public field = MatterFields.DEPOSIT;
	public ICON = ICON;

	constructor(private matDialog: MatDialog) {}

	_onFocus() {
		this.onFocus.emit(this.field);
	}

	openDepositModal() {
		const data: DepositDialogData = {
			matterId: this.matterId,
		};
		this.matDialog.open(DepositDialogComponent, { data });
	}
}
